import { useContext, useEffect, useState } from "react";
import { Select, MenuItem } from "@mui/material";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import { useLocation, useNavigate } from "react-router-dom";
import USFlag from "../../images/flags/uk-flag-icon.png";
import FranceFlag from "../../images/flags/french-flag-icon.png";
import tickethublogo from "../../images/logo_ticket_hub_row.png";
import { useAuth } from "../../context/AuthContext";
import { LanguageContext } from "../../context/LanguageContext";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InsightsIcon from "@mui/icons-material/Insights";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useTheme } from "@mui/material/styles";

export default function LeftMenu() {
  const theme = useTheme();
  const { translate, language, setLanguage } = useContext(LanguageContext);
  const { currentUser } = useAuth();
  const [userRole, setUserRole] = useState();
  const navigate = useNavigate();
  const handleLanguageChange = (e) => setLanguage(e.target.value);
  const location = useLocation();

  useEffect(() => {
    if (!currentUser) return;
    const unsub = onSnapshot(
      doc(db, "profilsUsers", currentUser.uid),
      (snap) => {
        if (snap.exists()) setUserRole(snap.data().role);
      }
    );
    return unsub;
  }, [currentUser]);

  return (
    // <div
    //   style={{
    //     width: "10%",
    //     backgroundColor: "#ffffff",
    //     height: "100vh",
    //     padding: "20px",
    //     paddingLeft: "10px",
    //     boxSizing: "border-box",
    //     display: "flex",
    //     flexDirection: "column",
    //     justifyContent: "space-between",
    //   }}
    // >
    <div
      style={{
        width: "10%",
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        height: "100vh",
        padding: "20px",
        paddingLeft: "10px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRight: `1px solid ${theme.palette.divider}`,
      }}
    >
      {/* Logo */}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            paddingLeft: "15px",
            paddingTop: "10px",
          }}
        >
          <img src={tickethublogo} alt="Logo" style={{ width: 130 }} />
        </div>
        <div style={{ paddingTop: "20px" }}>
          <List disablePadding>
            {userRole !== "Suspended" && (
              <ListItemButton
                selected={window.location.pathname === "/app/"}
                onClick={() => navigate("/app/")}
                sx={{
                  borderRadius: 1,
                  mb: 1,
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  color: theme.palette.text.primary,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: 0,
                    justifyContent: "center",
                    color: "inherit",
                  }}
                >
                  <ConfirmationNumberIcon />
                </ListItemIcon>
                <ListItemText
                  primary={translate("Tickets")}
                  primaryTypographyProps={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "inherit",
                  }}
                />
              </ListItemButton>
            )}
            <ListItemButton
              selected={window.location.pathname === "/app/dashboard"}
              onClick={() => navigate("/app/dashboard")}
              sx={{
                borderRadius: 1,
                mb: 1,
                display: "flex",
                alignItems: "center",
                gap: "10px",
                color: theme.palette.text.primary,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: 0,
                  justifyContent: "center",
                  color: "inherit",
                }}
              >
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText
                primary={translate("Dashboard")}
                primaryTypographyProps={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "inherit",
                }}
              />
            </ListItemButton>

            {/* <ListItemButton
              onClick={() => navigate("/app/ticketinsights")}
              selected={window.location.pathname === "/app/ticketinsights"}
              sx={{
                borderRadius: 1,
                mb: 1,
                display: "flex",
                alignItems: "center",
                gap: "10px",
                color: theme.palette.text.primary,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0, // supprime la largeur minimale de 56px
                  mr: 0, // pas de marge droite supplémentaire
                  justifyContent: "center",
                  color: "inherit",
                }}
              >
                <InsightsIcon />
              </ListItemIcon>
              <ListItemText
                primary={translate("TicketInsights")}
                primaryTypographyProps={{
                  fontSize: "14px", // <- taille de la police
                  fontWeight: 500, // optionnel, pour le poids
                  color: "inherit",
                }}
              />
            </ListItemButton> */}
            <ListItemButton
              selected={window.location.pathname === "/app/help"}
              onClick={() => navigate("/app/help")}
              sx={{
                borderRadius: 1,
                display: "flex",
                alignItems: "center",
                gap: "10px",
                color: theme.palette.text.primary,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0, // supprime la largeur minimale de 56px
                  mr: 0, // pas de marge droite supplémentaire
                  justifyContent: "center",
                  color: "inherit",
                }}
              >
                <HelpOutlineIcon />
              </ListItemIcon>
              <ListItemText
                primary={translate("HelpFAQs")}
                primaryTypographyProps={{
                  fontSize: "14px", // <- taille de la police
                  fontWeight: 500, // optionnel, pour le poids
                  color: "inherit",
                }}
              />
            </ListItemButton>
          </List>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignContent: "flex-start",
            alignItems: "center",
          }}
        >
          <Select
            value={language}
            onChange={handleLanguageChange}
            displayEmpty
            IconComponent={() => null}
            sx={{
              height: 30,
              minWidth: 50,
              pl: 1,
              pr: 0,

              "&:before, &:after": { border: 0 },
              // centre parfaitement la « select box »
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "& .MuiSelect-select": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                p: 0,
              },
              bgcolor: theme.palette.background.paper,
              color: theme.palette.text.primary,
            }}
          >
            {/** chaque item centré lui aussi **/}
            <MenuItem
              value="en"
              sx={{ display: "flex", alignItems: "center", gap: 1, py: 0.5 }}
            >
              <img src={USFlag} alt="" width={20} />
              English
            </MenuItem>
            <MenuItem
              value="fr"
              sx={{ display: "flex", alignItems: "center", gap: 1, py: 0.5 }}
            >
              <img src={FranceFlag} alt="" width={20} />
              Français
            </MenuItem>
          </Select>
        </div>
      </div>
    </div>
  );
}
